import type Button from '@123/druid/dist/Components/Button/Button';
import type StringMap from '@123/druid/dist/Types/StringMap';
import Strings from '@123/druid/dist/Utility/Strings';

export default class ButtonFactory {
    /**
     * Create standard button
     */
    public static createButton(label: string, icon?: string, attributes?: StringMap): Button {
        const button = <Button>document.createElement('dr-button');
        button.setLabel(label);
        button.innerHTML = label;
        if (attributes !== undefined) {
            Object.keys(attributes).forEach((key) => button.setAttribute(Strings.camelToKebabCase(key), attributes[key]));
        }

        if (icon) {
            button.setIcon(icon);
        }

        return button;
    }

    /**
     * Create prefab no button
     */
    public static createNoButton(): Button {
        return ButtonFactory.createButton('%%LANG_NO%%', 'dr-icon-restricted', {dataTest: 'no-btn'});
    }

    /**
     * Create prefab ok button
     */
    public static createOkButton(): Button {
        return ButtonFactory.createButton('%%LANG_OK%%', 'dr-icon-ok-tick', {dataTest: 'ok-btn'});
    }

    /**
     * Create prefab yes button
     */
    public static createYesButton(): Button {
        return ButtonFactory.createButton('%%LANG_YES%%', 'dr-icon-ok-tick', {dataTest: 'yes-btn'});
    }
}
